import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efec69ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "el-upload-list__item-actions" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import { Plus, UploadFilled } from '@element-plus/icons-vue'
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type { UploadFile, ElUploadProgressEvent, ElFile } from 'element-plus/es/components/upload/src/upload.type'

       
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref('')
       const dialogVisible = ref(false)
      const bindData = reactive({
        areaId:"",
        list : []
    })

   const albumEvent = () => {
        store
          .dispatch("albumModule/listAlbum", {})
          .then(
            (data) => {
              console.log(data);
                bindData.list = data.result;
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };
     const deleteEvent = (id:string) => {
        var params = {
           id:id
        }
        store
          .dispatch("albumModule/deleteAlbum", params)
          .then(
            (data) => {
               if(data.status == 2000){
                  albumEvent();
               }
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };
    albumEvent();
    const handleRemove = (file:UploadFile,id:string) =>{
        deleteEvent(id);
     }

     const handlePictureCardPreview = (file: UploadFile) => {
        dialogImageUrl.value = file.url!
        dialogVisible.value = true
     }

    const uploadSuccessEvent = (response: any, file: UploadFile, fileList: UploadFile[]) => {
    }
    
  

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).list, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_form_item, {
            key: item.id,
            label: item.label
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                "file-list": item.images,
                action: _unref(tool).url('/personalCenter/uploadAlbumImg'),
                "list-type": "picture-card",
                "on-preview": handlePictureCardPreview,
                "on-remove": handleRemove,
                "on-success": uploadSuccessEvent,
                data: {type:item.id}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  })
                ]),
                file: _withCtx(({ file }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      class: "el-upload-list__item-thumbnail",
                      src: file.url,
                      alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("span", {
                        class: "el-upload-list__item-preview",
                        onClick: ($event: any) => (handlePictureCardPreview(file))
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_zoom_in)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_4),
                      (!_ctx.disabled)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "el-upload-list__item-delete",
                            onClick: ($event: any) => (handleRemove(file,file.id))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_5))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["file-list", "action", "data"])
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_6)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})